// extracted by mini-css-extract-plugin
module.exports = {"container":"cursor_container__1pdjc","text":"cursor_text__3_Zk5"};